import styled from "@emotion/styled/macro";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";

export const UnreadIndicatorWrapper = styled(Box)`
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 16px;
  background: ${({ theme }) => (theme as Theme).palette.primary.main};
  color: ${({ theme }) => (theme as Theme).palette.primary.contrastText};
  box-shadow: ${({ theme }) => (theme as Theme).shadows[3]};
  pointer-events: none;
`;

export const UnreadIndicatorIcon = styled(KeyboardArrowUpIcon)`
  font-size: 16px;
`;

export const UnreadIndicatorText = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.02em;
  white-space: nowrap;
`;
